import { useEffect, useRef } from 'react';

// HOOK: the most recent `value` for which `keep` held, else the last kept value (seeded with
// `initial`) — holds a value steady across a transient state, e.g. a count blipping to 0.
export const useLastValueWhere = <T>(value: T, keep: (value: T) => boolean, initial: T): T => {
  const ref = useRef(initial);
  const kept = keep(value);
  useEffect(() => { if (kept) ref.current = value; }, [kept, value]);
  return kept ? value : ref.current;
};
